import { Loader2 } from "lucide-react";
import { Navigate } from "react-router";

import { AppShell } from "@/components/app-shell";
import { useMe } from "@/lib/api";

// Both guards render the shared AppShell (sidebar + top bar + feedback tab +
// welcome dialog) around the routed page — pages only render their content.

export function ProtectedRoute() {
  const { data: me, isLoading, error } = useMe();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="text-muted h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (error || !me) {
    return <Navigate to="/login" replace />;
  }

  return <AppShell />;
}

export function AdminRoute() {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="text-muted h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" replace />;
  }

  if (me.role !== "admin") {
    return <Navigate to="/home" replace />;
  }

  return <AppShell />;
}
